import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Product from './pages/Product';
import Contact from './pages/Contact';
import TrackOrder from './pages/TrackOrder';
import OurStory from './pages/OurStory';
import Ingredients from './pages/Ingredients';
import Privacy from './pages/policies/Privacy';
import Refund from './pages/policies/Refund';
import Terms from './pages/policies/Terms';
import Shipping from './pages/policies/Shipping';
import ContactInfo from './pages/policies/ContactInfo';
import CheckoutSuccess from './pages/CheckoutSuccess';
import Header from './components/Header';
import Footer from './components/Footer';
import TopBanner from './components/TopBanner';
import MysteryModal from './components/MysteryModal';
import CartDrawer from './components/CartDrawer';
import ScrollToTop from './components/ScrollToTop';
import { CartProvider } from './components/CartContext';
import { CurrencyProvider } from './components/CurrencyContext';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <CurrencyProvider>
        <CartProvider>
          <BrowserRouter>
          <ScrollToTop />
          <TopBanner />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products/korean-scalp-revival-bar" element={<Product />} />
            <Route path="/products/:slug" element={<Product />} />
            <Route path="/pages/contact" element={<Contact />} />
            <Route path="/pages/track-your-order" element={<TrackOrder />} />
            <Route path="/pages/our-story" element={<OurStory />} />
            <Route path="/pages/ingredients" element={<Ingredients />} />
            <Route path="/policies/privacy-policy" element={<Privacy />} />
            <Route path="/policies/refund-policy" element={<Refund />} />
            <Route path="/policies/terms-of-service" element={<Terms />} />
            <Route path="/policies/shipping-policy" element={<Shipping />} />
            <Route path="/policies/contact-information" element={<ContactInfo />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/catalog" element={<Home />} />
          </Routes>
          <Footer />
          <CartDrawer />
          <MysteryModal />
          <Toaster position="top-center" />
        </BrowserRouter>
        </CartProvider>
      </CurrencyProvider>
    </div>
  );
}

export default App;
